$(function () {
	if ($('.jq_listing').length || $('.jq_listing_control').length) {
		if ($.fn.ajaxify) {
			initAjaxListing();
		} else {
			$.getScript(siteConfig.shared + 'jquery.ajaxify.js', initAjaxListing);
		}
	}

	function initAjaxListing() {
		$('.jq_listing_control:not(".ajaxified")').each(function() {
			var $control = $(this);

			var listingIndex = $control.data('listing-index');

			$control.ajaxify({
				history: false,
				refresh: [
					{
						selector: '.listing-id-' + listingIndex,
						append: true
					},
					{
						selector: '.listing-control-' + listingIndex
					}
				],
				onFinish: function(response) {
					if ('statusText' in response && response.statusText == 'success') {
						initAjaxListing();
					}
				}
			});
		});

		var $listingTriggers = $('.jq_listing:not(".ajaxified")');

		if ($listingTriggers.length) {
			var listingObserver = new IntersectionObserver(function(items, instance) {
				$.each(items, function(i, item) {
					if (item.isIntersecting || item.intersectionRatio > 0) {
						instance.unobserve(item.target);

						var $listingTrigger = $(item.target);

						var listingIndex =typeof $listingTrigger.data('listing-index') !== 'undefined' ? $listingTrigger.data('listing-index') : '';

						var listingUrl = typeof $listingTrigger.data('listing-url') !== 'undefined' ? $listingTrigger.data('listing-url') : '';

						if (listingIndex !== '' && listingUrl !== '') {
							$.ajaxLink(
								listingUrl,
								{
									history: false,
									refresh: {
										selector: '.listing-id-' + listingIndex,
									}
								}
							);
						}
					}
				});
			}, {
				rootMargin: '-20% 0%'
			});

			$listingTriggers.each(function() {
				listingObserver.observe(this);
			});
		}
	}
});
